import { gql } from '@apollo/client';
import { ErrorMessageInfo, WarrantyInfoShared } from '@retainerclub/shared-api';

export default gql`
  mutation actionWarrantyStatus(
    $input: WarrantyStatusActionInput!
  ) {
    actionWarrantyStatus(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      warranty {
        ...WarrantyInfoShared
      }
    }
  }
  ${WarrantyInfoShared}
  ${ErrorMessageInfo}
`;
